import React from 'react';
import {Button} from '@betareader/design-system';

/**
 * Inline formatting toolbar for a scene editor. Mirrors the Draft inline
 * toolbar buttons (see components/textEditor/inlineToolbarButtons.js):
 * bold / italic / underline / H2 / H3. onMouseDown is prevented so clicking a
 * button keeps the editor selection.
 */
const preventDefault = event => event.preventDefault();

const SceneToolbar = ({editor}) => {
  if (!editor) return null;

  const run = fn => event => {
    event.preventDefault();
    fn();
  };

  const actions = [
    {label: 'Bold', text: <strong>B</strong>, active: editor.isActive('bold'),
      apply: () => editor.chain().focus().toggleBold().run()},
    {label: 'Italic', text: <em>I</em>, active: editor.isActive('italic'),
      apply: () => editor.chain().focus().toggleItalic().run()},
    {label: 'Underline', text: <u>U</u>, active: editor.isActive('underline'),
      apply: () => editor.chain().focus().toggleUnderline().run()},
    {label: 'Heading 2', text: 'H2', active: editor.isActive('heading', {level: 2}),
      apply: () => editor.chain().focus().toggleHeading({level: 2}).run()},
    {label: 'Heading 3', text: 'H3', active: editor.isActive('heading', {level: 3}),
      apply: () => editor.chain().focus().toggleHeading({level: 3}).run()}
  ];

  return <div role="toolbar" aria-label="Scene formatting" className="scene-toolbar">
    {actions.map(({label, text, active, apply}) =>
      <Button key={label} variant="ghost" size="small" aria-label={label}
        aria-pressed={active} onMouseDown={preventDefault}
        onClick={run(apply)}>{text}</Button>)}
  </div>;
};

export default SceneToolbar;
